/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import Navbar from './navbar';
import BaseUrls from '../../utils/baseUrls';

const Layout = ({ children }: { children: React.ReactNode }) => {
  const [showMobileSidebar, setShowMobileSidebar] = useState<boolean>(false);
  const sidebarModuleUrl = BaseUrls.getSidebarModuleUrl();

  const handleClose = () => {
    setShowMobileSidebar(false);
  };

  const handleShow = () => {
    setShowMobileSidebar(true);
  };

  return (
    // layout
    <div
      className="d-flex bg-white"
      style={{
        overflowY: 'hidden',
        height: '100vh',
      }}
    >
      {/* side navbar */}
      <iframe
        src={sidebarModuleUrl}
        className="flex-column d-none d-lg-flex"
        title="sidebar"
        style={{
          width: '288px',
          backgroundColor: '#080E12',
        }}
      />
      {/* mobile side navbar */}
      <Offcanvas
        style={{
          backgroundColor: '#080E12',
        }}
        show={showMobileSidebar}
        onHide={handleClose}
        id="mobile-side-navbar"
      >
        <iframe
          src={sidebarModuleUrl}
          className="d-flex d-lg-none"
          height="100%"
          width="100%"
          title="mobile sidebar"
          style={{
            backgroundColor: '#080E12',
          }}
        />
      </Offcanvas>
      {/* right section */}
      <div
        className="d-flex flex-column"
        style={{
          height: '100%',
          backgroundColor: '#F6F6F6',
          flex: '1 1 0%',
          overflow: 'hidden',
        }}
      >
        {/* header navbar */}
        <Navbar onMenuButtonClick={handleShow} />
        {/* main section */}
        <div
          style={{
            maxHeight: '100%',
            flex: '1 1 0%',
            overflowX: 'hidden',
            overflowY: 'auto',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;